var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.51,3.86h-1.73V2.68c0-0.87-0.7-1.57-1.57-1.57h-0.06c-0.87,0-1.57,0.7-1.57,1.57v1.18H8.44V2.68 c0-0.87-0.7-1.57-1.57-1.57H6.8c-0.87,0-1.57,0.7-1.57,1.57v1.18H3.49c-0.87,0-1.57,0.7-1.57,1.57v16.88 c0,0.87,0.7,1.57,1.57,1.57h18.01c0.87,0,1.57-0.7,1.57-1.57V5.44C23.08,4.57,22.38,3.86,21.51,3.86z M20.44,21.4H4.56V8.62 h15.87V21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72,14.41h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25H6.72c-0.14,0-0.25,0.11-0.25,0.25v2.74 C6.47,14.29,6.58,14.41,6.72,14.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13,14.41h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25h-2.74c-0.14,0-0.25,0.11-0.25,0.25v2.74 C10.88,14.29,10.99,14.41,11.13,14.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54,14.41h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25h-2.74c-0.14,0-0.25,0.11-0.25,0.25v2.74 C15.29,14.29,15.4,14.41,15.54,14.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72,18.81h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25H6.72c-0.14,0-0.25,0.11-0.25,0.25v2.74 C6.47,18.7,6.58,18.81,6.72,18.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.13,18.81h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25h-2.74c-0.14,0-0.25,0.11-0.25,0.25v2.74 C10.88,18.7,10.99,18.81,11.13,18.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54,18.81h2.74c0.14,0,0.25-0.11,0.25-0.25v-2.74c0-0.14-0.11-0.25-0.25-0.25h-2.74c-0.14,0-0.25,0.11-0.25,0.25v2.74 C15.29,18.7,15.4,18.81,15.54,18.81z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c9949bc73585dd30a919b2b08ed08feb.svg";
export { ForwardRef as ReactComponent };